var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.059 1.25448C25.1416 1.05984 25.0929 0.834239 24.9373 0.691063C24.7816 0.547888 24.5528 0.518103 24.3657 0.616676L0.766579 13.0505C0.580341 13.1486 0.475508 13.3529 0.504367 13.5614C0.533225 13.7699 0.689593 13.938 0.895479 13.9819L10.7742 16.0861L13.6931 25.7554C13.7539 25.957 13.9345 26.0988 14.1447 26.1102C14.3549 26.1216 14.5497 26.0001 14.632 25.8064L25.059 1.25448Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransit);
export default __webpack_public_path__ + "static/media/transit.e38848bc68a561d94e2bd13cf1306421.svg";
export { ForwardRef as ReactComponent };